import { IFile } from '@/types/admin/resources';

export const ensureWebFileParts = async (files: IFile[]): Promise<IFile[]> => {
  // Only attempt on web where File/Blob are available
  const g: any = globalThis as any;
  const isWeb = typeof g !== 'undefined' && typeof g.File !== 'undefined' && typeof g.Blob !== 'undefined';
  if (!isWeb) return files;

  const hydrated = await Promise.all(
    files.map(async (f) => {
      // If already has a browser File or RN part, keep as-is
      const maybePart: any = (f as any).file;
      if (maybePart && (typeof maybePart.arrayBuffer === 'function' || maybePart.uri)) {
        return f;
      }
      if (!f.uri) return f;
      try {
        const res = await fetch(f.uri);
        const buf = await res.arrayBuffer();
        const BlobCtor = g.Blob;
        const FileCtor = g.File;
        const blob = new BlobCtor([buf], { type: f.type || 'application/octet-stream' });
        const webFile = new FileCtor([blob], f.name || 'file', { type: blob.type });
        return { ...f, file: webFile as any };
      } catch {
        return f;
      }
    })
  );
  return hydrated;
};

export const normalizeFilesForUpload = async (files: IFile[] | any[]): Promise<IFile[]> => {
  let normalized: IFile[] = (files || []).map((f: any) => ({
    id: f?.id,
    name: f?.name,
    size: f?.size ?? 0,
    type: f?.type,
    uri: f?.uri,
    file: f?.file,
  }));
  normalized = await ensureWebFileParts(normalized);
  return normalized;
};


